export class MGMemberEntity {
    mgMemberId: string
    userId: string
    createdAt: Date
    updatedAt: Date
    status: number
    publicStatus: number
    indicatedName: string
    indicatedPhone: string
    indicatedEmail?: string
    indicatedSegment: string
    comments?: string
    managerId?: string
}

export enum MGMembersPublicStatusEnum {
    new = 5,
    rejected = 10,
    qualified = 50,
    followed = 55,
    contacted = 60,
    negotiating = 65,
    lost = 80,
    success = 100,
}

export enum MGMPublicStatusFriendly {
    new = 'Novo',
    rejected = 'Rejeitado',
    qualified = 'Aceito',
    followed = 'Em andamento',
    contacted = 'Contactado',
    negotiating = 'Negociando',
    lost = 'Perdido',
    success = 'Ganho',
}
